<main id="main" class="player-list-main front">
    <div class="mobile_version-backbutton"><a onclick="history.back()" class="mobile-header"><span><img
                    src="../../../assets/images/tournament/backBtn.svg" alt=""></span>Registered Players </a></div>
    <!-- ======= Product Section ======= -->

    <div class="topTitle">
        <h2>Registered Players</h2>
    </div>
    <section class="team Tournaments-list">
        <div class="container">
            <div class="mainDivBody"
                [ngClass]="loggedInAcademyId === tournamentAcademyId == true ? 'own-Tournament' : ''">
                <div class="card mainDetailsCard">
                    <div class="col-md-12 p-p-0">
                        <div class="right-side-section col-md-12 p-p-0">
                            <div class="wrapper max-w-3xl mx-auto px-0">
                                <div class="item">
                                    <div class="row">
                                        <div class="col-md-12 body-header">
                                            <div class="media w-100 justify-content-space-between mb-3">
                                                <!-- <div class="media-left"><div class="back-button"><i class='bx bx-left-arrow-alt'></i>
                                                          Back
                                                      </div></div> -->
                                                <div class="media-body">
                                                    <h4 class="text-left">{{tournamentname}}</h4>
                                                    <!-- <p *ngIf="playersList" class="header-para">Player Entries</p>
                                                    <p *ngIf="!playersList" class="header-para">No Player Register Yet
                                                        !!</p> -->
                                                    <div class="dateDiv">{{ tournamentData?.startdate |
                                                        date:'dd/MM/yyyy' }}
                                                        - {{
                                                        tournamentData?.enddate |
                                                        date:'dd/MM/yyyy' }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <p-accordion [activeIndex]="0" expandIcon="pi pi-chevron-down"
                                            collapseIcon="pi pi-chevron-up">
                                            <ng-container *ngFor="let data of categoryList; let index = index">
                                                <p-accordionTab>
                                                    <ng-template pTemplate="header">
                                                        <div
                                                            class="custom-header d-flex justify-content-space-between w-100">

                                                            <div class="w-100 title-div-header">
                                                                <button type="button">
                                                                    <span
                                                                        class="categoryName">{{data.matchtypeData[0].name}}</span>
                                                                    <span class="pipe">|</span> <span class="ageGroup">
                                                                        AgeGroup:
                                                                        {{data.ageGroupData[0].name}}
                                                                    </span>

                                                                </button>
                                                                <span
                                                                    class="badge primery mr-3 ">{{data.playerListData?.length
                                                                    || 0}}</span>
                                                            </div>


                                                            <!-- <div class="trash-icon" *ngIf="!data?.drawStatus"
                                                            (click)="deleteCategoryDialog(data.matchtypeData[0].name,data.playerListData?.length,data._id)">
                                                            <img src="../../../assets/images/backend-image/common-images/deleteBtn.svg"
                                                                alt="">
                                                        </div> -->
                                                        </div>

                                                    </ng-template>
                                                    <ng-template pTemplate>
                                                        <div class="col-md-12 category-body-table-div">
                                                            <table class="table mainTablePlayer">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">PLAYERS NAME </th>

                                                                        <th scope="col">ENTRY FEE</th>
                                                                        <th scope="col" class="pmdtaTd"
                                                                            *ngIf="showPuneTournaments" class="pmdtaTd">
                                                                            PMDTA No.</th>
                                                                    </tr>
                                                                </thead>
                                                                <div *ngIf="data.playerListData?.length<1">
                                                                    <div class="p-p-3"> No player registered yet</div>
                                                                </div>
                                                                <tbody>
                                                                    <tr
                                                                        *ngFor="let players of data.playerListData; let index = index">

                                                                        <td scope="row">
                                                                            <div class="palyer">
                                                                                <div class="media">
                                                                                    <div class="position">
                                                                                        {{index+1}} .
                                                                                    </div>
                                                                                    <div class="media-left">
                                                                                        <div class="user-image">
                                                                                            <img src={{players.photo}}
                                                                                                alt="">
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="media-body">
                                                                                        <h4 class="playerName"
                                                                                            *ngIf="players?.playerDetails.length > 0">
                                                                                            {{players?.playerDetails[0]["fullName"]
                                                                                            }}
                                                                                        </h4>
                                                                                        <span>
                                                                                            <h4
                                                                                                *ngIf="players?.doubleplayerDetails?.length>0">
                                                                                                /
                                                                                                {{players.doubleplayerDetails[0]["fullName"]}}
                                                                                            </h4>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </td>

                                                                        <td> <span
                                                                                class="fees">₹{{players.entryFee}}</span>
                                                                        </td>
                                                                        <!-- <td *ngIf="loggedInAcademyId === tournamentAcademyId">{{players.pmdtaNumber}}</td> -->
                                                                        <td *ngIf="showPuneTournaments" class="pmdtaTd">
                                                                            <span class="double-pmdta"
                                                                                *ngIf="loggedInAcademyId === tournamentAcademyId || loggedInUserId === players.playerDetails[0]['_id']">{{players.pmdtaNumber}}</span>
                                                                            <span class="double-pmdta"
                                                                                *ngIf="loggedInAcademyId === tournamentAcademyId || loggedInUserId === players?.doubleplayerDetails?.length > 0">
                                                                                <span class="double-icon"
                                                                                    *ngIf="players.doublePlayerPmdtaNumber">
                                                                                    /</span>
                                                                                {{players.doublePlayerPmdtaNumber}}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </ng-template>
                                                </p-accordionTab>
                                            </ng-container>
                                        </p-accordion>
                                    </div>
                                </div>
                                <!-- Modal -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </section>
    <!-- End Product -->
    <div class="modal fade" id="widthdraw-confitmation" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="EntertournamentLabel">Delete Category
                    </h5>

                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                        data-bs-toggle="modal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <p style="margin-bottom: 0px;">
                        Are you sure you want to delete this tournament category?
                    </p>




                    <div class="add-even col-md-12">
                        <!-- <div class="event-number">Add Partner</div> -->

                        <div class="event-details-list">
                            <div class="list-div-selection">
                                <div class="event-details">

                                    <div class="Event-cate mb-2 mt-2">
                                        <ul>
                                            <li>

                                                <p class="mb-0">Junior Boy's Singles | 07 Participants have already
                                                    registered
                                                </p>
                                            </li>


                                        </ul>
                                        <!-- <div class="edite">
                <button> <span><i class='bx bx-edit-alt'></i></span> Edit</button>
            </div> -->

                                    </div>

                                </div>

                            </div>
                        </div>
                        <p style="margin-bottom: 0rem;"> This action cannot be undone and will remove all associated
                            tournaments and player
                            registrations. Entry fees will be refunded to all players.</p>



                        <!-- <div class="add-btn col-md-12">
<button> Add Another Event <i class='bx bx-plus'></i> </button>
</div> -->

                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-primary mx-auto "
                        style="border-color: red; background-color: red;color: #fff;" data-bs-target="#widthdraw"
                        data-bs-toggle="modal"> <span><i class='bx bx-trash'
                                style="font-size:16px;color: #fff;"></i></span> Delete
                        Category</button>
                </div>
            </div>
        </div>
    </div>
</main>
<!-- End #main -->

<p-dialog header="Delete Category" [(visible)]="categoryDelet" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false" id="widthdraw-confitmation">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

            <div class="modal-body">

                <p style="margin-bottom: 0px;">
                    Are you sure you want to delete this tournament category?
                </p>




                <div class="add-even col-md-12 p-p-0">
                    <!-- <div class="event-number">Add Partner</div> -->

                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">

                                <div class="Event-cate mb-2 mt-2">
                                    <ul>
                                        <li>

                                            <p class="mb-0">{{matchtypeName}} | {{count}} Participants have already
                                                registered
                                            </p>
                                        </li>


                                    </ul>
                                    <!-- <div class="edite">
            <button> <span><i class='bx bx-edit-alt'></i></span> Edit</button>
        </div> -->

                                </div>

                            </div>

                        </div>
                    </div>
                    <p style="margin-bottom: 0rem;"> This action cannot be undone and will remove all associated
                        tournaments and player
                        registrations. Entry fees will be refunded to all players.</p>



                    <!-- <div class="add-btn col-md-12">
<button> Add Another Event <i class='bx bx-plus'></i> </button>
</div> -->

                </div>
            </div>

        </div>
    </div>
    <ng-template pTemplate="footer" class="modal-footer">


        <button type="button" class="btn btn-primary mx-auto " (click)="deleteCategoryFunction()"
            style="border-color: red; background-color: red;color: #fff;" data-bs-target="#widthdraw"
            data-bs-toggle="modal"> <span><i class='bx bx-trash' style="font-size:16px;color: #fff;"></i></span>
            Delete
            Category</button>

    </ng-template>
</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdraw"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '38rem' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important; width: 100%;
max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Category Deleting</h5>
                <div class="headings col-md-12">

                    <h6>{{tournamentname}}</h6>

                    <div class="countdown-container">
                        <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
                        <div class="countdown-text">{{ countdown }}</div>
                        <br>

                    </div>
                    <div class="timer-alert">
                        Please wait
                    </div>
                    <p class="note">We are processing your request for a refund in the tournament category. Once the
                        refund
                        process is successfully completed, please check wallet Balance.</p>

                </div>

            </div>
        </div>
    </div>
</p-dialog>